const panelToggle = () => {
  const panelToggle = $('.panelToggle');
  const toggle = $('[data-panel-toggle]');
  const panel = $('[data-panel-toggle-show]');
  toggle.click(function() {
    const thisToggle = $(this);
    toggle.removeClass('is-active');
    thisToggle.addClass('is-active');
    panel.removeClass('fade-in');
    panel.attr('data-panel-toggle-show', 'false');
    const id = thisToggle.data('panel-toggle');
    const thisPanel = $(`#${id}`);
    thisPanel.attr('data-panel-toggle-show', 'true');
    thisPanel.addClass('fade-in');
  });
};

export default panelToggle;